import React, { ChangeEvent, useState } from 'react';
import { IconPassword } from '../../assets/icons';
import { InputMui } from '../input-mui/input-mui';

type InputPasswordProps = {
  value: string;
  disabled?: boolean;
  label: string;
  id?: string;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  errorMessage?: string;
  name?: string;
  reverse?: boolean;
};

export const InputPassword: React.FC<InputPasswordProps> = (props) => {
  const [showPassword, setShowPassword] = useState<boolean>(false);

  const toggleShowPassword = (event: React.PointerEvent<HTMLButtonElement>) => {
    event.preventDefault();
    setShowPassword(!showPassword);
  };

  return (
    <InputMui
      {...props}
      type={showPassword ? 'text' : 'password'}
      reverse={props.reverse}
      endIcon={
        <button onClick={toggleShowPassword} className="input__icon" type="button">
          <IconPassword isOn={!showPassword} />
        </button>
      }
    />
  );
};
